export default {
  teal: "#00AD9F",
  tealDark: "#15847D",
  tealBright: "#00E0CE",
  pink: "#FF6969",
  pinkDark: "#FF1154",
  pinkAccessible: "#E8114E",
  orange: "#F86816",
  orangeDark: "#B74808",
  blue: "#43B4D8",
  blueDark: "#146396",
  blueDarkB: "#133857",
  violet: "#C57AA2",
  violetDark: "#7C0C64",
  purple: "#4f005e",
  purpleDark: "#33065b",
  yellow: "#FFAD43",
  yellowDark: "#CC801F",
  white: "#fff",
  white2: "#FBFBFB",
  black: "#000",
  black2: "#060606",
  black3: "#0e1e25",
  gray1: "#2D3B41",
  gray2: "#646E73",
  gray3: "#757575",
  gray4: "#BDBDBD",
  gray5: "#E0E0E0",
  gray6: "#F7F8F8",
  blackAlpha1: `rgba(0,0,0,.025)`,
  blackAlpha2: `rgba(0,0,0,.1)`,
  whiteAlpha1: `rgba(255,255,255,.05)`,
}
